import React from 'react';
import { Upload, MessageSquare, Sparkles, CheckCircle2 } from 'lucide-react';

const steps = [
  {
    icon: Upload,
    title: 'Upload Your Resume',
    description: 'Our AI parses your resume to understand your skills, experience, and career goals.',
  },
  {
    icon: MessageSquare,
    title: 'AI Interview',
    description: 'Complete a quick AI-powered interview to showcase your expertise and communication skills.',
  },
  {
    icon: Sparkles,
    title: 'Get Matched',
    description: 'Our algorithm matches you with roles that fit your profile and preferences.',
  },
  {
    icon: CheckCircle2,
    title: 'Start Working',
    description: 'Apply to matched roles, connect with employers, and begin your new opportunity.',
  },
];

const HowItWorks = () => {
  return (
    <section className="py-16 px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2 text-center">How It Works</h2>
        <p className="text-gray-500 text-center mb-12">Get matched with top opportunities in 4 simple steps</p>
        
        <div className="grid md:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-8 left-[60%] w-full h-0.5 bg-gradient-to-r from-indigo-200 to-transparent" />
              )}
              
              <div className="text-center relative z-10">
                <div className="w-16 h-16 bg-indigo-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <step.icon className="w-8 h-8 text-indigo-600" />
                </div>
                <span className="inline-flex items-center justify-center w-6 h-6 bg-indigo-600 text-white text-xs font-semibold rounded-full mb-3">
                  {index + 1}
                </span>
                <h3 className="font-semibold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-500 text-sm">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
